module.exports = __webpack_public_path__ + "img/docusaurus.09a7b121.svg";